import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { Outlet, useNavigation } from 'react-router-dom'
import Loading from './Loading'
import { CartProvider } from '../context/CartContext'
import { WishlistProvider } from '../context/WishlistContext'

function AppLayout() {
  const loadingNavigation = useNavigation()

  return (
    <WishlistProvider>
      <CartProvider>
        {loadingNavigation.state === 'loading' ? (
          <Loading />
        ) : (
          <>
            <Header />
            <Outlet />
            <Footer />
          </>
        )}
      </CartProvider>
    </WishlistProvider>
  )
}

export default AppLayout
